import { ReactNode } from "react";
import styles from "./Detail.module.scss";

interface DetailProps {
  label: ReactNode;
  value: ReactNode;
}

const Detail = ({ label, value }: DetailProps) => (
  <div className={styles.detail}>
    <span className={styles.label}>{label}</span>
    <span className={styles.value}>{value}</span>
  </div>
);

export default Detail;
